import { z } from 'zod'

export const schema = z.object({
  rentUnitsPrice: z.array(
    z.object({
      rentUnitId: z.string(),
      pricesByPlaces: z.array(
        z.object({
          places: z.number().int(),
          price: z.object({
            amount: z.number().int(),
            currency: z.string(),
          }),
        }),
      ),
      hasNoDatesAvailable: z.boolean(),
      isMinNightsRequired: z.boolean(),
      minNights: z.number().int(),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>
